import { PushNotification } from 'components';
import { useNavigate } from 'react-router-dom';
import { Box, Stack, IconButton, Divider, Paper } from '@mui/material';

import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';

import Offline from './Offline';
import TasksWidget from './TasksWidget';
import ThemePopover from './ThemePopover';
// import ProfilePopover from './ProfilePopover';
// import LanguagePopover from './LanguagePopover';

export default function Navbar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const back = () => navigate(-1);

  return (
    <Box
      height={72}
      component="header"
      sx={{
        top: 0,
        zIndex: 1000,
        position: 'sticky',
      }}
    >
      <Offline />
      <Paper
        sx={{
          height: '100%',
          bgcolor: 'primary.main',
          borderRadius: '0 0 8px 8px',
        }}
      >
        <Stack p={1} height="100%" direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" columnGap={1}>
            <IconButton
              size="small"
              onClick={onOpenSidebar}
              sx={{ color: '#fff', bgcolor: 'action.hover' }}
              // sx={{ display: { xs: "none", sm: "flex" } }}
            >
              <MenuRoundedIcon fontSize="small" color="inherit" />
            </IconButton>
            <Divider
              orientation="vertical"
              sx={{ height: 24, borderColor: '#fff', display: { xs: 'none', md: 'flex' } }}
            />
            {/* <Typography variant="h2" color="#fff">
              Hyperano
            </Typography> */}
            <img width={48} height={48} src="logo.svg" style={{ objectFit: 'contain' }} />
          </Stack>
          <Stack direction="row-reverse" alignItems="center" columnGap={0.5}>
            <IconButton size="small" onClick={back} sx={{ color: '#fff', bgcolor: 'action.hover' }}>
              <ArrowBackIosNewRoundedIcon fontSize="small" color="inherit" />
            </IconButton>
            {/* <IconButton color="warning" onClick={openTour}>
            <HelpOutlineRoundedIcon fontSize="small" />
          </IconButton> */}
            <TasksWidget title="کارتابل" />
            <PushNotification />
            <ThemePopover />
            {/* <LanguagePopover /> */}
            {/* <ProfilePopover /> */}
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
